import React, { Component } from 'react'
import styled from 'styled-components'

const Item = styled.div`
  margin-left: 1vw;
  font-family: OpensansRegular;
  font-size: 0.6vw;
  text-transform: uppercase;
  color: #333;
`
const ItemMarked = Item.extend`
  font-family: OpensansBold;
`
const FilterItem = ({ marked, label, onClick }) => {
  if (marked) {
    return <ItemMarked>{label}</ItemMarked>
  } else {
    return <Item onClick={() => onClick()}>{label}</Item>
  }
}

export default FilterItem



// WEBPACK FOOTER //
// ./src/components/filter-item.js